import { getStyle } from './getStyle';
import * as Moment from 'moment';
import * as React from 'react';
import { Text, View } from '@react-pdf/renderer';

export function getFooter(footnote?: string, footnote_page?: number): JSX.Element {
    if (footnote) {
        return (
            <View fixed style={{ ...getStyle('footer_multi') }}>
                <View>
                    <Text
                        style={{ color: '#888', fontSize: '9pt', paddingBottom: '1pt' }}
                        render={({ pageNumber, totalPages }) => {
                            if (!footnote_page || footnote_page === pageNumber) {
                                return footnote + ' --> ' + footnote_page + ' === ' + pageNumber;
                            }
                            return '';
                        }}
                    />
                </View>
                <View style={{ ...getStyle('footer_multi_inner') }}>
                    <Text>
                        {Moment().format('DD.MM.YYYY')}
                    </Text>
                    <Text fixed
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `Seite | ${pageNumber}`;
                            }
                        }}
                    />
                </View>
            </View>
        );
    }
    return (
        <View fixed style={{ ...getStyle('footer') }}>
            <Text>
                {Moment().format('DD.MM.YYYY')}
            </Text>
            <Text fixed
                render={({ pageNumber, totalPages }) => {
                    if (totalPages > 1) {
                        return `Seite | ${pageNumber}`;
                    }
                }}
            />
        </View>
    );
}

